import { aroApiSlice } from './apiSlice';
import { getBaseURL } from '../../../utilities/config';

// To Do: use baseURL and remove full url from query
export const productApiSlice = aroApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getProductResource: builder.query({
            query: ({ resource, queryParams }) => {
                const queryString = queryParams
                    ? `&${Object.entries(queryParams)
                        .map(([key, value]) => `${key}=${value}`)
                        .join('&')}`
                    : '';
                return `${getBaseURL()}/product?resource=${resource}${queryString}`;
            },
        }),
        getAllProductResources: builder.query({
            query: () => `${getBaseURL()}/product`,
            transformResponse: (response) => {
                const resources = Object.values(response.home_products).map(
                    (product) => {
                        const versions = Object.values(product.versions).map((version) => ({
                            ...version,
                            // Filtering is temporary to avoid confusion with water meter option info all over the place
                            option_types: Object.values(version.option_types).filter(
                                (opt) =>
                                    !['Existing Water Meter', 'New Water Meter'].includes(
                                        opt.name
                                    )
                            ),
                        }));
                        return {
                            ...product,
                            versions,
                        };
                    }
                );
                return {
                    home_products: resources,
                };
            },
        }),
    }),
});

export const {
    useGetAllProductResourcesQuery,
    useLazyGetProductResourceQuery,
} = productApiSlice;
